import zImage from './src/main.vue';
zImage.install = (Vue) => {
	Vue.component(zImage.name, zImage);
};
export default zImage;
